module.exports = __webpack_public_path__ + "static/media/avatarReactionIcon.f9922451.svg";